/** Peças comuns às páginas Sífilis e HIV. */
import { ROTULO_STATUS_NOTIFICACAO, type StatusNotificacao } from '@metaepi/shared';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Cartao, SeloStatus, type TipoStatus } from '../../components/ui';
import { NomeGestante } from '../pacientes/PaginaPacientes';
import { igHoje } from '../pacientes/formatos';
import type { FaseAgravo } from './api';

const ROTULO_FASE: Record<FaseAgravo, string> = {
  pre_natal: 'Pré-natal',
  internada: 'Internada',
  pos_parto: 'Pós-parto',
};

/** Número de destaque no topo da página. */
export function Contador({
  rotulo,
  valor,
  tipo = 'neutro',
}: {
  rotulo: string;
  valor: number;
  tipo?: TipoStatus;
}) {
  const cor = tipo === 'perigo' ? 'text-perigo' : tipo === 'alerta' ? 'text-alerta' : 'text-texto';
  return (
    <Cartao className="flex flex-col gap-1">
      <p className="text-sm text-texto-suave">{rotulo}</p>
      <p className={`text-3xl font-bold ${valor > 0 ? cor : 'text-texto'}`}>{valor}</p>
    </Cartao>
  );
}

export function GradeContadores({ children }: { children: ReactNode }) {
  return (
    <section aria-label="Resumo" className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {children}
    </section>
  );
}

export function CelulaGestante({
  item,
  aba,
}: {
  item: { paciente_id: string; nome: string; nome_social: string | null };
  aba: string;
}) {
  return (
    <Link
      to={`/pacientes/${item.paciente_id}?aba=${aba}`}
      className="font-medium text-primaria hover:underline"
    >
      <NomeGestante nome={item.nome} nomeSocial={item.nome_social} />
    </Link>
  );
}

export function CelulaFase({ fase, dum }: { fase: FaseAgravo; dum: string | null }) {
  const ig = fase === 'pre_natal' ? igHoje(dum) : null;
  return (
    <span className="flex flex-col">
      <span>{ROTULO_FASE[fase]}</span>
      {ig && <span className="text-xs text-texto-suave">{ig}</span>}
    </span>
  );
}

/** Notificação SINAN: só deixa de ser pendência com a ficha gerada (D-032). */
export function SeloNotificacao({ status }: { status: string | null }) {
  if (!status) return <SeloStatus tipo="alerta">Não criada</SeloStatus>;
  const feita = status === 'pdf_gerado' || status === 'notificada';
  return (
    <SeloStatus tipo={feita ? 'sucesso' : 'alerta'}>
      {ROTULO_STATUS_NOTIFICACAO[status as StatusNotificacao] ?? status}
    </SeloStatus>
  );
}
